/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EventTypeList = {
    type: 'array',
    contains: {
        type: 'EventType',
    },
} as const;
